import React, { FC, useContext, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { EntityType } from '../../../entity/entity.types';
import { EntityCasesByJurisdiction } from '../../../entity/expertises/EntityCasesByJurisdiction';
import { EntityDomains } from '../../../entity/expertises/EntityDomains';
import { EntityCasesByCity } from '../../../entity/expertises/EntityCasesByCity';
import { LawFirmKeywordsFetcher } from './LawFirmKeywordsFetcher';
import { EntityKeywords } from '../../../entity/expertises/keywords/EntityKeywords';
import { LawFirmContext } from '../LawFirmContext';
import { PageNavContext } from '../../../components/page-nav/PageNavContext';
import { EntityOutlineTitle } from '../../../entity/components/EntityOutlineTitle';

export const LawFirmCases: FC = () => {
  const id = 'law-firm-expertises';
  const {
    lawFirmInfos: { lawOfficeIdGroup, name },
    experience: { domains, juridictions, villes, decisionCount },
  } = useContext(LawFirmContext);
  const { createNav } = useContext(PageNavContext);
  const entityInfos: {
    entityId: string;
    entityName: string;
    entityType: EntityType;
  } = {
    entityId: lawOfficeIdGroup,
    entityName: name,
    entityType: 'lawFirm',
  };

  useEffect(() => {
    createNav(id);
  }, []);

  return (
    <>
      <EntityOutlineTitle id={id}>
        <FormattedMessage id="law-firm/page/LawFirmCases.tsx/1" /> {name}
      </EntityOutlineTitle>
      {domains.length > 0 && (
        <EntityDomains
          domains={domains}
          decisionCount={decisionCount}
          {...entityInfos}
        />
      )}
      {juridictions.length > 0 && (
        <EntityCasesByJurisdiction
          casesByJurisdiction={juridictions}
          decisionCount={decisionCount}
          {...entityInfos}
        />
      )}
      {villes.length > 0 && (
        <EntityCasesByCity
          casesByCity={villes}
          decisionCount={decisionCount}
          {...entityInfos}
        />
      )}
      <LawFirmKeywordsFetcher lawOfficeIdGroup={lawOfficeIdGroup}>
        {(keywords) =>
          keywords.length > 0 && (
            <EntityKeywords
              keywords={keywords.map((keyword) => ({ word: keyword }))}
              decisionCount={decisionCount}
              {...entityInfos}
            />
          )
        }
      </LawFirmKeywordsFetcher>
    </>
  );
};
